// Simple i18n dictionary for AR/EN
export const dict = {
  ar: {
    appName: "RARE GROUP",
    appTagline: "ورد وهدايا فاخرة — توصيل خلال ساعة",
    home: "الرئيسية",
    shop: "المتجر",
    ai: "الذكاء",
    orders: "الطلبات",
    profile: "حسابي",
    cart: "السلة",
    search: "ابحث عن ورد، كيك، هدايا...",
    categories: "التصنيفات",
    featured: "منتجات مختارة",
    allProducts: "جميع المنتجات",
    addToCart: "أضف إلى السلة",
    added: "تمت الإضافة",
    buyNow: "اطلب الآن",
    price: "السعر",
    checkout: "إتمام الطلب",
    deliveryWithinHour: "توصيل خلال ساعة",
    goldenGuarantee: "ضمان ذهبي",
    multiCurrency: "عملات متعددة",
    login: "تسجيل الدخول",
    register: "إنشاء حساب",
    logout: "تسجيل الخروج",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم",
    phone: "رقم الجوال",
    continueWithGoogle: "المتابعة مع Google",
    continueWithApple: "المتابعة مع Apple",
    continueWithEmail: "المتابعة بالبريد الإلكتروني",
    noAccount: "ليس لديك حساب؟",
    hasAccount: "لديك حساب؟",
    myOrders: "طلباتي",
    orderCode: "رقم الطلب",
    status: "الحالة",
    total: "الإجمالي",
    emptyCart: "سلتك فارغة",
    emptyCartHint: "تصفح متجرنا وأضف هدايا مميزة",
    startShopping: "ابدأ التسوق",
    remove: "إزالة",
    quantity: "الكمية",
    deliveryAddress: "عنوان التوصيل",
    recipientName: "اسم المستلم",
    recipientPhone: "جوال المستلم",
    deliveryDate: "تاريخ/وقت التوصيل",
    greetingMessage: "رسالة إهداء (اختياري)",
    generateGreeting: "توليد رسالة بالذكاء",
    generateCard: "توليد تصميم كرت",
    placeOrder: "تأكيد الطلب",
    paymentMock: "دفع تجريبي (MOCK)",
    orderSuccess: "تم استلام طلبك بنجاح!",
    earnedPoints: "كسبت نقاط المحفظة",
    wallet: "المحفظة",
    points: "نقطة",
    walletBalance: "رصيد النقاط",
    walletValue: "قيمة النقاط",
    walletHistory: "سجل المعاملات",
    walletEarned: "تم كسبها",
    walletRedeemed: "تم استخدامها",
    walletViewAll: "عرض المحفظة",
    walletUsePoints: "استخدم نقاطك",
    walletPointsAvailable: "نقطة متاحة",
    walletUseMax: "استخدام الحد الأقصى",
    walletHowToEarn: "كيف تكسب النقاط؟",
    walletEarnHint: "تحصل على نقطة واحدة لكل 10 ريال، وكل 10 نقاط = 1 ريال خصم",
    walletMinRedeem: "الحد الأدنى 50 نقطة",
    walletNoTxn: "لا توجد معاملات بعد",
    walletApply: "تطبيق",
    walletClear: "إلغاء",
    walletDiscount: "خصم النقاط",
    txnEarn: "كسب",
    txnRedeem: "استرداد",
    txnWelcome: "مكافأة ترحيبية",
    txnRefund: "استرداد",
    txnAdjust: "تعديل",
    // AI studio
    aiStudio: "استوديو الذكاء",
    aiStudioDesc: "ميزات مدعومة بالذكاء الاصطناعي لتجربة مميزة",
    aiChatbot: "المساعدة الذكية",
    aiChatbotDesc: "دعم فوري 24/7",
    aiGiftRec: "اقتراح هدية",
    aiGiftRecDesc: "حسب المناسبة والميزانية",
    aiBouquet: "تصميم باقة",
    aiBouquetDesc: "اقتراح باقة من وصفك",
    aiMessage: "رسالة تهنئة",
    aiMessageDesc: "3 رسائل فورية",
    aiCard: "تصميم كرت",
    aiCardDesc: "صورة كرت فريدة",
    // Chat
    chatPlaceholder: "اكتب سؤالك هنا...",
    send: "إرسال",
    // Gift recommend
    occasion: "المناسبة",
    budget: "الميزانية",
    relationship: "العلاقة",
    preferences: "تفضيلات إضافية",
    recommend: "اقترح لي",
    // Bouquet
    bouquetDesc: "صف الجو أو المناسبة...",
    bouquetDescPh: "مثال: باقة رومانسية بألوان دافئة لذكرى زواج",
    // Greeting
    recipientNameField: "اسم المستلم",
    senderName: "اسم المرسل",
    tone: "النبرة",
    toneWarm: "دافئة",
    toneFormal: "رسمية",
    toneFunny: "طريفة",
    tonePoetic: "شعرية",
    generate: "توليد",
    // Card
    cardPrompt: "وصف الكرت",
    cardPromptPh: "مثال: كرت عيد ميلاد بورود وبلالين",
    cardStyle: "النمط",
    styleElegant: "فاخر",
    stylePlayful: "مرح",
    styleMinimal: "بسيط",
    styleFloral: "ورود",
    generateImage: "توليد الصورة",
    downloadImage: "تحميل الصورة",
    // Statuses
    awaiting_payment: "بانتظار الدفع",
    pending: "قيد الانتظار",
    preparing: "قيد التحضير",
    out_for_delivery: "في الطريق",
    delivered: "تم التسليم",
    cancelled: "ملغي",
    // Admin/Staff
    admin: "الإدارة",
    staff: "الموظفين",
    dashboard: "لوحة التحكم",
    products: "المنتجات",
    users: "المستخدمين",
    revenue: "الإيرادات",
    ordersQueue: "طابور الطلبات",
    markPreparing: "بدء التحضير",
    markDelivered: "تم التسليم",
    markOut: "إرسال للتوصيل",
    dept_florist: "قسم الورد",
    dept_baker: "قسم الخباز",
    dept_barista: "قسم القهوة",
    dept_gifts: "قسم الهدايا",
    dept_purchasing: "قسم المشتريات",
    backToHome: "العودة للرئيسية",
    welcome: "أهلاً بك",
    welcomeBack: "مرحباً بعودتك",
    orTryDemo: "أو جرّب حساب تجريبي",
    demoLogin: "دخول بحساب تجريبي",
    language: "اللغة",
    currency: "العملة",
    tryAI: "جرّب الذكاء الاصطناعي",
    viewAll: "عرض الكل",
    new: "جديد",
    bestSeller: "الأكثر مبيعاً",
    trackOrder: "تتبع الطلب",
    confirmPay: "تأكيد الدفع",
    summary: "ملخص الطلب",
    items: "منتجات",
    reward: "نقاط المكافأة",
    useCard: "استخدم الكرت في الطلب",
    cardUsed: "تم حفظ الكرت ✓",
    fullName: "الاسم الكامل",
    save: "حفظ",
    cancel: "إلغاء",
    edit: "تعديل",
    delete: "حذف",
    add: "إضافة",
    noItems: "لا توجد عناصر",
    searchPlaceholder: "ابحث...",
    category: "التصنيف",
    stock: "المخزون",
    // Branches
    branches: "فروعنا",
    branchesTitle: "فروعنا في الخليج",
    branchesSubtitle: "خدمتك متوفرة في 6 دول خليجية",
    branch: "الفرع",
    country: "الدولة",
    city: "المدينة",
    selectCountry: "اختر الدولة",
    selectBranch: "اختر الفرع",
    chooseBranch: "اختر فرعك",
    callBranch: "اتصل",
    whatsappBranch: "واتساب",
    fulfilledFrom: "يتم التحضير من",
    noActiveBranches: "لا توجد فروع فعّالة حالياً",
    assignBranch: "تعيين الفرع",
    unassigned: "غير معيّن",
    // Admin panel
    adminOverview: "نظرة عامة",
    adminAnalytics: "تحليلات",
    adminCoupons: "الكوبونات",
    adminBanners: "البانرات",
    adminCategories: "التصنيفات",
    adminSettings: "الإعدادات",
    revenueLast30: "إيرادات آخر 30 يوم",
    revenueLast7: "إيرادات آخر 7 أيام",
    topProducts: "المنتجات الأكثر مبيعاً",
    branchPerformance: "أداء الفروع",
    newUsers: "مستخدمون جدد",
    aiInsights: "تحليلات AI",
    topCoupons: "أعلى الكوبونات استخداماً",
    cardMethods: "طرق توصيل الكرت",
    exportCSV: "تصدير CSV",
    search: "بحث",
    filter: "فلترة",
    from: "من",
    to: "إلى",
    clearFilter: "إلغاء الفلاتر",
    newUser: "إضافة مستخدم",
    newCoupon: "إضافة كوبون",
    newBanner: "إضافة بانر",
    newCategory: "إضافة تصنيف",
    adjustWallet: "تعديل النقاط",
    addPoints: "إضافة نقاط",
    deductPoints: "خصم نقاط",
    reason: "السبب",
    fxRates: "أسعار الصرف",
    loyaltyRules: "قواعد الولاء",
    deliveryFee: "رسوم التوصيل",
    saveSettings: "حفظ الإعدادات",
    darkMode: "الوضع الداكن",
    lightMode: "الوضع الفاتح",
    collapse: "طي",
    expand: "توسيع",
    qty: "الكمية",
    orderNo: "رقم الطلب",
    customer: "العميل",
    active: "فعّال",
    inactive: "معطّل",
    confirm: "تأكيد",
    aiCopilot: "المساعد الذكي",
    copilotTagline: "اسألني عن أي بيانات أعمالك",
    copilotPlaceholder: "مثال: وش أفضل فرع هذا الشهر؟",
    copilotSend: "إرسال",
    copilotClear: "محادثة جديدة",
    copilotLoading: "يحلل البيانات...",
    // ——— Merchant join wizard (mj*) ———
    mjTitle: "انضم كتاجر في RG",
    mjTagline: "سجّل محلك واستقبل طلبات عملاء RG — عمولة فقط عند البيع.",
    mjStepVerify: "التحقق",
    mjStepInfo: "بيانات المحل",
    mjStepLocation: "الموقع والدوام",
    mjStepDocs: "المستندات",
    mjStepReview: "المراجعة",
    mjOtpHeader: "التحقق بالبريد الإلكتروني",
    mjOtpHint: "نرسل لك رمزاً لتأكيد بريدك وإنشاء حسابك (التحقق عبر واتساب سيتوفر عند اعتماد قالب OTP).",
    mjEmailLabel: "البريد الإلكتروني",
    mjOtpCodeLabel: "رمز التحقق",
    mjOtpSend: "إرسال رمز التحقق",
    mjOtpConfirm: "تأكيد الرمز",
    mjNameAr: "اسم المحل (عربي)",
    mjNameEn: "اسم المحل (إنجليزي)",
    mjOwnerName: "اسم المسؤول",
    mjPhone: "رقم الجوال",
    mjActivity: "نوع النشاط",
    mjCountry: "الدولة",
    mjCity: "المدينة",
    mjCityPh: "الدوحة",
    mjArea: "المنطقة",
    mjBio: "نبذة عن المحل",
    mjMapHeader: "موقع المحل على الخريطة",
    mjMapHint: "اضغط على موقع محلك في الخريطة",
    mjAddress: "العنوان الوصفي",
    mjAddressPh: "شارع، مبنى، علامة مميزة...",
    mjHoursHeader: "أوقات العمل",
    mjClosed: "مغلق",
    mjTo: "إلى",
    mjDelivery: "التوصيل",
    mjDeliveryRg: "🛵 توصيل RG (سائقونا يستلمون منك)",
    mjDeliverySelf: "🚗 أوصّل بنفسي",
    mjDaySat: "السبت", mjDaySun: "الأحد", mjDayMon: "الاثنين", mjDayTue: "الثلاثاء",
    mjDayWed: "الأربعاء", mjDayThu: "الخميس", mjDayFri: "الجمعة",
    mjDocsHeader: "المستندات والحساب البنكي",
    mjCrNumber: "رقم السجل التجاري",
    mjCrImage: "صورة السجل التجاري",
    mjExtraDocs: "مستندات إضافية (اختياري)",
    mjDocsCount: "مستند",
    mjIban: "رقم الحساب البنكي / IBAN",
    mjLogo: "شعار المحل",
    mjPhotos: "صور المحل (حتى 5)",
    mjUpload: "رفع ملف",
    mjRemove: "حذف",
    mjUploadOk: "تم الرفع ✓",
    mjErrFileRead: "تعذر قراءة الملف — جرّب ملفاً آخر",
    mjReviewTitle: "مراجعة الطلب",
    mjRevStore: "المحل",
    mjRevLogoOk: "شعار ✓",
    mjRevOwner: "المسؤول",
    mjRevActivity: "النشاط",
    mjRevLocation: "الموقع",
    mjRevMapOk: "📍 محدد على الخريطة",
    mjRevDelivery: "التوصيل",
    mjRevDeliveryRg: "توصيل RG",
    mjRevDeliverySelf: "توصيل ذاتي",
    mjRevCr: "السجل التجاري",
    mjRevImageOk: "صورة ✓",
    mjReviewNotice: "بعد الإرسال يصبح طلبك قيد المراجعة ولن يظهر محلك للعملاء إلا بعد موافقة إدارة RG.",
    mjBack: "رجوع",
    mjNext: "التالي",
    mjSubmit: "إرسال طلب الانضمام ✓",
    mjErrNameRequired: "اسم المحل مطلوب",
    mjErrOwnerRequired: "اسم المسؤول مطلوب",
    mjErrPhoneRequired: "رقم الجوال مطلوب",
    mjErrActivityRequired: "اختر نوع النشاط",
    mjErrCityRequired: "المدينة مطلوبة",
    mjErrSendOtp: "فشل إرسال الرمز",
    mjErrBadOtp: "رمز غير صحيح",
    mjErrSubmit: "فشل الإرسال",
    mjErrWait: "انتظر {s} ثانية قبل طلب رمز جديد",
    mjErrEmailProvider: "خدمة البريد غير مفعّلة حالياً — حاول لاحقاً",
    mjErrOtpFormat: "الرمز يجب أن يكون 4 أو 6 أرقام",
    mjErrNoCode: "لا يوجد رمز فعّال لهذا البريد — أرسل رمزاً جديداً",
    mjErrCodeExpired: "انتهت صلاحية الرمز — أرسل رمزاً جديداً",
    mjErrTooMany: "محاولات كثيرة — أرسل رمزاً جديداً",
    mjErrExisting: "لديك طلب مسجل مسبقاً (حالته: {s})",
    mjErrActivityMissing: "نوع النشاط غير موجود",
    mjDoneTitle: "تم استلام طلبك بنجاح 🎉",
    mjDoneBody: "طلب انضمام «{name}» الآن قيد المراجعة.",
    mjDoneHint: "سنراجع مستنداتك ونفعّل محلك خلال وقت قصير — ستصلك رسالة عند الموافقة.",
    mjDashboard: "لوحة التاجر",
    mjPleaseLogin: "يرجى تسجيل الدخول",
    mjStaffLogin: "دخول موظفي المتاجر 👤",
    mjStaffSuspended: "⚠️ حسابك موقوف مؤقتاً — تواصل مع صاحب المتجر",
    mjStaffTerminated: "انتهت خدمتك في هذا المتجر",
    mjNoStore: "ليس لديك محل مسجل بعد.",
    mjJoinNow: "انضم كتاجر الآن",
    mjStatusPending: "⏳ طلبك قيد المراجعة",
    mjStatusSuspended: "⚠️ محلك معلّق مؤقتاً — تواصل مع الإدارة",
    mjStatusRejected: "تم رفض الطلب",
    mjReason: "السبب",
  },
  en: {
    appName: "RARE GROUP",
    appTagline: "Premium flowers & gifts — delivered within an hour",
    home: "Home",
    shop: "Shop",
    ai: "AI",
    orders: "Orders",
    profile: "Profile",
    cart: "Cart",
    search: "Search flowers, cakes, gifts...",
    categories: "Categories",
    featured: "Featured",
    allProducts: "All Products",
    addToCart: "Add to cart",
    added: "Added",
    buyNow: "Buy now",
    price: "Price",
    checkout: "Checkout",
    deliveryWithinHour: "1-hour delivery",
    goldenGuarantee: "Golden guarantee",
    multiCurrency: "Multi-currency",
    login: "Log in",
    register: "Create account",
    logout: "Sign out",
    email: "Email",
    password: "Password",
    name: "Name",
    phone: "Phone",
    continueWithGoogle: "Continue with Google",
    continueWithApple: "Continue with Apple",
    continueWithEmail: "Continue with email",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    myOrders: "My Orders",
    orderCode: "Order #",
    status: "Status",
    total: "Total",
    emptyCart: "Your cart is empty",
    emptyCartHint: "Browse our store and add something special",
    startShopping: "Start shopping",
    remove: "Remove",
    quantity: "Qty",
    deliveryAddress: "Delivery address",
    recipientName: "Recipient name",
    recipientPhone: "Recipient phone",
    deliveryDate: "Delivery date/time",
    greetingMessage: "Greeting message (optional)",
    generateGreeting: "Generate message with AI",
    generateCard: "Generate card design",
    placeOrder: "Place order",
    paymentMock: "Mock payment (test)",
    orderSuccess: "Your order has been received!",
    earnedPoints: "You earned wallet points",
    wallet: "Wallet",
    points: "pts",
    walletBalance: "Points balance",
    walletValue: "Value",
    walletHistory: "Transaction history",
    walletEarned: "Earned",
    walletRedeemed: "Redeemed",
    walletViewAll: "View wallet",
    walletUsePoints: "Use your points",
    walletPointsAvailable: "points available",
    walletUseMax: "Use max",
    walletHowToEarn: "How to earn?",
    walletEarnHint: "Earn 1 point per 10 QAR spent. Each 10 points = 1 QAR off.",
    walletMinRedeem: "Minimum 50 points",
    walletNoTxn: "No transactions yet",
    walletApply: "Apply",
    walletClear: "Clear",
    walletDiscount: "Points discount",
    txnEarn: "Earned",
    txnRedeem: "Redeemed",
    txnWelcome: "Welcome bonus",
    txnRefund: "Refund",
    txnAdjust: "Adjustment",
    // AI studio
    aiStudio: "AI Studio",
    aiStudioDesc: "AI-powered features for a premium experience",
    aiChatbot: "Smart Assistant",
    aiChatbotDesc: "Instant support 24/7",
    aiGiftRec: "Gift Finder",
    aiGiftRecDesc: "By occasion & budget",
    aiBouquet: "Bouquet Designer",
    aiBouquetDesc: "From your description",
    aiMessage: "Greeting Writer",
    aiMessageDesc: "3 instant messages",
    aiCard: "Card Designer",
    aiCardDesc: "Unique card image",
    chatPlaceholder: "Type your question...",
    send: "Send",
    occasion: "Occasion",
    budget: "Budget",
    relationship: "Relationship",
    preferences: "Preferences",
    recommend: "Recommend",
    bouquetDesc: "Describe the vibe or occasion...",
    bouquetDescPh: "e.g. Romantic warm-tone bouquet for anniversary",
    recipientNameField: "Recipient name",
    senderName: "Sender name",
    tone: "Tone",
    toneWarm: "Warm",
    toneFormal: "Formal",
    toneFunny: "Funny",
    tonePoetic: "Poetic",
    generate: "Generate",
    cardPrompt: "Card description",
    cardPromptPh: "e.g. Birthday card with roses and balloons",
    cardStyle: "Style",
    styleElegant: "Elegant",
    stylePlayful: "Playful",
    styleMinimal: "Minimal",
    styleFloral: "Floral",
    generateImage: "Generate image",
    downloadImage: "Download",
    awaiting_payment: "Awaiting payment",
    pending: "Pending",
    preparing: "Preparing",
    out_for_delivery: "Out for delivery",
    delivered: "Delivered",
    cancelled: "Cancelled",
    admin: "Admin",
    staff: "Staff",
    dashboard: "Dashboard",
    products: "Products",
    users: "Users",
    revenue: "Revenue",
    ordersQueue: "Orders Queue",
    markPreparing: "Start preparing",
    markDelivered: "Mark delivered",
    markOut: "Dispatch",
    dept_florist: "Florist",
    dept_baker: "Bakery",
    dept_barista: "Barista",
    dept_gifts: "Gifts",
    dept_purchasing: "Purchasing",
    backToHome: "Back home",
    welcome: "Welcome",
    welcomeBack: "Welcome back",
    orTryDemo: "Or try a demo account",
    demoLogin: "Demo login",
    language: "Language",
    currency: "Currency",
    tryAI: "Try AI features",
    viewAll: "View all",
    new: "New",
    bestSeller: "Best seller",
    trackOrder: "Track order",
    confirmPay: "Confirm & pay",
    summary: "Order summary",
    items: "items",
    reward: "Reward points",
    useCard: "Attach card to order",
    cardUsed: "Card attached ✓",
    fullName: "Full name",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    add: "Add",
    noItems: "No items",
    searchPlaceholder: "Search...",
    category: "Category",
    stock: "Stock",
    // Branches
    branches: "Our branches",
    branchesTitle: "Our branches across the GCC",
    branchesSubtitle: "Serving 6 Gulf countries",
    branch: "Branch",
    country: "Country",
    city: "City",
    selectCountry: "Select country",
    selectBranch: "Select branch",
    chooseBranch: "Choose your branch",
    callBranch: "Call",
    whatsappBranch: "WhatsApp",
    fulfilledFrom: "Fulfilled from",
    noActiveBranches: "No active branches right now",
    assignBranch: "Assign branch",
    unassigned: "Unassigned",
    // Admin panel
    adminOverview: "Overview",
    adminAnalytics: "Analytics",
    adminCoupons: "Coupons",
    adminBanners: "Banners",
    adminCategories: "Categories",
    adminSettings: "Settings",
    revenueLast30: "Revenue · last 30d",
    revenueLast7: "Revenue · last 7d",
    topProducts: "Top products",
    branchPerformance: "Branch performance",
    newUsers: "New customers",
    aiInsights: "AI insights",
    topCoupons: "Top coupons",
    cardMethods: "Card delivery split",
    exportCSV: "Export CSV",
    search: "Search",
    filter: "Filter",
    from: "From",
    to: "To",
    clearFilter: "Clear filters",
    newUser: "New user",
    newCoupon: "New coupon",
    newBanner: "New banner",
    newCategory: "New category",
    adjustWallet: "Adjust wallet",
    addPoints: "Add points",
    deductPoints: "Deduct points",
    reason: "Reason",
    fxRates: "FX rates",
    loyaltyRules: "Loyalty rules",
    deliveryFee: "Delivery fee",
    saveSettings: "Save settings",
    darkMode: "Dark",
    lightMode: "Light",
    collapse: "Collapse",
    expand: "Expand",
    qty: "Qty",
    orderNo: "Order #",
    customer: "Customer",
    active: "Active",
    inactive: "Inactive",
    confirm: "Confirm",
    aiCopilot: "AI Copilot",
    copilotTagline: "Ask anything about your business",
    copilotPlaceholder: "e.g. Which branch performed best this month?",
    copilotSend: "Send",
    copilotClear: "New chat",
    copilotLoading: "Analyzing data...",
    // ——— Merchant join wizard (mj*) ———
    mjTitle: "Join RG as a Merchant",
    mjTagline: "Register your store and receive RG customer orders — commission only when you sell.",
    mjStepVerify: "Verification",
    mjStepInfo: "Store Information",
    mjStepLocation: "Location & Working Days",
    mjStepDocs: "Documents",
    mjStepReview: "Review",
    mjOtpHeader: "Email Verification",
    mjOtpHint: "We'll send a code to confirm your email and create your account (WhatsApp verification available soon).",
    mjEmailLabel: "Email",
    mjOtpCodeLabel: "Verification code",
    mjOtpSend: "Send verification code",
    mjOtpConfirm: "Confirm code",
    mjNameAr: "Store name (Arabic)",
    mjNameEn: "Store name (English)",
    mjOwnerName: "Owner / manager name",
    mjPhone: "Mobile number",
    mjActivity: "Business activity",
    mjCountry: "Country",
    mjCity: "City",
    mjCityPh: "Doha",
    mjArea: "Area",
    mjBio: "About the store",
    mjMapHeader: "Store location on the map",
    mjMapHint: "Tap your store's location on the map",
    mjAddress: "Address details",
    mjAddressPh: "Street, building, landmark...",
    mjHoursHeader: "Working hours",
    mjClosed: "Closed",
    mjTo: "to",
    mjDelivery: "Delivery",
    mjDeliveryRg: "🛵 RG delivery (our drivers pick up from you)",
    mjDeliverySelf: "🚗 I deliver myself",
    mjDaySat: "Saturday", mjDaySun: "Sunday", mjDayMon: "Monday", mjDayTue: "Tuesday",
    mjDayWed: "Wednesday", mjDayThu: "Thursday", mjDayFri: "Friday",
    mjDocsHeader: "Documents & Bank Account",
    mjCrNumber: "Commercial registration (CR) number",
    mjCrImage: "CR document image",
    mjExtraDocs: "Additional documents (optional)",
    mjDocsCount: "document(s)",
    mjIban: "Bank account / IBAN",
    mjLogo: "Store logo",
    mjPhotos: "Store photos (up to 5)",
    mjUpload: "Upload file",
    mjRemove: "Remove",
    mjUploadOk: "Uploaded ✓",
    mjErrFileRead: "Could not read the file — try another one",
    mjReviewTitle: "Review your application",
    mjRevStore: "Store",
    mjRevLogoOk: "logo ✓",
    mjRevOwner: "Owner",
    mjRevActivity: "Activity",
    mjRevLocation: "Location",
    mjRevMapOk: "📍 pinned on map",
    mjRevDelivery: "Delivery",
    mjRevDeliveryRg: "RG delivery",
    mjRevDeliverySelf: "Self delivery",
    mjRevCr: "CR number",
    mjRevImageOk: "image ✓",
    mjReviewNotice: "After submission your application will be under review — your store won't appear to customers until RG approves it.",
    mjBack: "Back",
    mjNext: "Next",
    mjSubmit: "Submit application ✓",
    mjErrNameRequired: "Store name is required",
    mjErrOwnerRequired: "Owner name is required",
    mjErrPhoneRequired: "A valid mobile number is required",
    mjErrActivityRequired: "Select a business activity",
    mjErrCityRequired: "City is required",
    mjErrSendOtp: "Failed to send the code",
    mjErrBadOtp: "Incorrect code",
    mjErrSubmit: "Submission failed",
    mjErrWait: "Please wait {s}s before requesting a new code",
    mjErrEmailProvider: "Email service is not configured — try again later",
    mjErrOtpFormat: "Code must be 4 or 6 digits",
    mjErrNoCode: "No active code for this email — request a new one",
    mjErrCodeExpired: "Code expired — request a new one",
    mjErrTooMany: "Too many attempts — request a new code",
    mjErrExisting: "You already have an application (status: {s})",
    mjErrActivityMissing: "Business activity not found",
    mjDoneTitle: "Your application was received 🎉",
    mjDoneBody: "The application for “{name}” is now under review.",
    mjDoneHint: "We'll review your documents and activate your store shortly — you'll be notified upon approval.",
    mjDashboard: "Merchant dashboard",
    mjPleaseLogin: "Please log in",
    mjStaffLogin: "Store staff login 👤",
    mjStaffSuspended: "⚠️ Your account is temporarily suspended — contact the store owner",
    mjStaffTerminated: "Your employment at this store has ended",
    mjNoStore: "You don't have a registered store yet.",
    mjJoinNow: "Join as a merchant now",
    mjStatusPending: "⏳ Your application is under review",
    mjStatusSuspended: "⚠️ Your store is temporarily suspended — contact support",
    mjStatusRejected: "Application rejected",
    mjReason: "Reason",
  },
};

export const t = (lang, key) => (dict[lang] && dict[lang][key]) || dict.en[key] || key;

// Localize known backend error `detail` strings (merchant join / email OTP flow).
// Falls back to `fallbackKey` when the raw detail's script doesn't match the UI language.
const API_ERR_MAP = [
  [/^Please wait (\d+)s/, "mjErrWait"],
  [/Email provider not configured/, "mjErrEmailProvider"],
  [/^Email send error/, "mjErrSendOtp"],
  [/OTP must be 4 or 6 digits/, "mjErrOtpFormat"],
  [/No active code/, "mjErrNoCode"],
  [/Code expired/, "mjErrCodeExpired"],
  [/Too many attempts/, "mjErrTooMany"],
  [/Incorrect code/, "mjErrBadOtp"],
  [/لديك طلب بحالة (.+) مسبقاً/, "mjErrExisting"],
  [/نوع النشاط غير موجود/, "mjErrActivityMissing"],
];
export const localizeApiError = (lang, detail, fallbackKey) => {
  const d = typeof detail === "string" ? detail : "";
  for (const [re, key] of API_ERR_MAP) {
    const m = d.match(re);
    if (m) return t(lang, key).replace("{s}", m[1] || "");
  }
  if (!d) return t(lang, fallbackKey);
  const hasArabic = /[\u0600-\u06FF]/.test(d);
  if ((lang === "en" && hasArabic) || (lang === "ar" && !hasArabic)) return t(lang, fallbackKey);
  return d;
};
